import React from "react";
import { Check, LayoutGrid, Pencil } from "lucide-react";
import { PlanResultsStrip } from "./PlanResultsStrip";

export const CHANGE_VALUE = "Aku mau mengubah salah satu bagian dulu.";
const WORKSPACE_VALUE = "Lanjutkan per bagian di Ruang Kerja";

// Natural composition: a part locked in the background → one quiet inline line under the reply, nothing else.
export function PlanProgressChip({ m }) {
  const p = m.plan_progress;
  if (!p || !(p.locked || []).length) return null;
  const ns = p.locked.map((s) => s.n);
  const label = ns.length === 1 ? `${p.unit} ${ns[0]}${p.locked[0].title ? ` · ${p.locked[0].title}` : ""}` : ns.every((n, i) => i === 0 || n === ns[i - 1] + 1) ? `${p.unit} ${ns[0]}–${ns[ns.length - 1]}` : `${p.unit} ${ns.join(", ")}`;
  return (
    <p className="fade-up mt-2 inline-flex max-w-full items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50/70 px-2.5 py-1 text-[11px] text-emerald-700" data-testid="plan-progress-chip">
      <Check size={11} className="shrink-0" /><span className="truncate" data-no-i18n>{label}</span><span className="shrink-0 text-emerald-600/80">— terkunci ({p.done}/{p.total})</span>
    </p>
  );
}

// The ONE combined card at the end: plan recap (+ «Ubah bagian…» / Ruang Kerja); the model & credits card or the «Buat …» buttons follow it.
export function PlanFinalCard({ m, onSend }) {
  const p = m.content_plan;
  if (p && m.tool === "package" && m.plan_final) return <PlanResultsStrip plan={p} cid={m.conversation_id} />; // after the run: the finished parts (revised badge, older versions) stay on this card
  if (!p || !(m.tool === "plan_final" || (m.tool === "package_offer" && m.plan_final))) return null;
  const secs = p.sections || [];
  const open = !m.tool_cancelled && m.tool === "package_offer" && !!m.pending_tool; // stays while the credits card is open (plan_final carries its own choice buttons)
  const KIND = { image: "panel", video: "adegan", presentation: "slide", document: "bagian" };
  return (
    <div className="mt-2 w-full max-w-xl rounded-2xl border border-[#2F6BFF]/25 bg-[#F5F8FF] p-3" data-testid="plan-final-card">
      <p className="mb-1 text-[11px] font-bold uppercase tracking-wider text-[#2F6BFF]">Rencana Konten · <span data-no-i18n>{p.title}</span> <span className="font-medium normal-case tracking-normal text-slate-400">{secs.length} {KIND[p.kind] || "bagian"} · semua sepakat</span></p>
      {p.premise && <p className="mb-1 text-xs text-slate-700" data-no-i18n>{p.premise}</p>}
      {p.style && <p className="mb-2 text-[11px] text-slate-500" data-no-i18n>Gaya: {p.style}</p>}
      <ol className="space-y-1">
        {secs.map((s) => (
          <li key={s.n} className="rounded-lg bg-white/70 px-2.5 py-1 text-xs text-slate-700" data-testid={`plan-final-section-${s.n}`}>
            <span className="font-semibold" data-no-i18n>#{s.n} {s.title}</span>{s.summary && <span className="text-slate-500" data-no-i18n> — {s.summary.length > 140 ? s.summary.slice(0, 140) + "…" : s.summary}</span>}{s.duration ? <span className="text-slate-400"> · {s.duration} dtk</span> : null}
          </li>
        ))}
      </ol>
      {open && (
        <div className="mt-2 flex flex-wrap gap-2">
          <button type="button" onClick={() => onSend(CHANGE_VALUE)} className="inline-flex items-center gap-1 rounded-xl border border-[#2F6BFF]/40 bg-white px-3 py-1.5 text-[11px] font-semibold text-[#2F6BFF] hover:bg-[#EEF3FF]" data-testid="plan-final-change"><Pencil size={11} /> Ubah bagian…</button>
          <button type="button" onClick={() => onSend(WORKSPACE_VALUE)} className="inline-flex items-center gap-1 rounded-xl border border-[#E7ECF3] bg-white px-3 py-1.5 text-[11px] font-semibold text-slate-600 hover:bg-slate-50" data-testid="plan-final-workspace" title="Setujui tiap bagian sebagai tahap terpisah"><LayoutGrid size={11} /> Ruang Kerja</button>
        </div>
      )}
      <PlanResultsStrip plan={p} cid={m.conversation_id} />
    </div>
  );
}
